import { ResourceType } from "~/business";
import { XResourceWithAmount } from "./XResourceWithAmount";
import { XTechCardSvg } from "./svg";

export const XAcquireTechCard = ({
  discount = 0,
  width,
}: {
  discount?: number;
  width: number;
}) => {
  const discountSize = width * 0.4;

  return (
    <div>
      <XTechCardSvg width={width} />
      {discount !== 0 && (
        <XResourceWithAmount
          amount={-discount}
          type={ResourceType.Spice}
          variant="compact"
          width={discountSize}
          style={{ position: "absolute", top: -2, left: -2 }}
        />
      )}
    </div>
  );
};
